"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetTradesRoutes = void 0;
const route_1 = require("../route");
class AssetTradesRoutes extends route_1.Route {
    constructor() {
        super('assets');
    }
    initializePurchase(originAmount, originAsset, destinationAsset) {
        return this.post('/purchase/initialize', { originAmount, originAsset, destinationAsset });
    }
    executePurchase(assetTradeId) {
        return this.post(`/purchase/execute/${assetTradeId}`);
    }
    initializeSell(originAsset, destinationAsset, destinationAmount) {
        return this.post('/sell/initialize', { originAsset, destinationAsset, destinationAmount });
    }
    executeSell(assetTradeId) {
        return this.post(`/sell/execute/${assetTradeId}`);
    }
    cancelTrade(assetTradeId) {
        return this.post(`/cancel/${assetTradeId}`);
    }
    getHistory(asset, limit) {
        return this.get(`/history`, { asset, limit });
    }
    getPriceHistory(asset, window) {
        return this.get('/historical-prices', { asset, window });
    }
    getUserConfiguration() {
        return this.get('/user-configuration');
    }
}
exports.AssetTradesRoutes = AssetTradesRoutes;
//# sourceMappingURL=asset_trades.js.map